import * as React from 'react';
import { useState } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';
import { forgotPassword, resetPassword } from '../../../../api/ProspectUser';
import { getSourceData } from '../../../../utilities/sourceData';
import { unformatPhoneNumber } from '../../../../utilities/Utils';
import FormValidationDisplay from '../../../common/form/ValidationDisplay';
import LoadingOverlay from '../../../common/LoadingOverlay';
import ProspectPhoneNumberEntry from './ProspectPhoneNumberEntry';
import SetPasswordWorkflow from './SetPasswordWorkflow';

interface Props extends RouteComponentProps<{}> {}

const PasswordResetPage = (props: Props) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

    var sourceData = getSourceData();
    const [mobileNumber, setMobileNumber] = useState<string>(sourceData.phone || '');
    const [phoneNumberEntered, setPhoneNumberEntered] = useState<boolean>(false);

    const handlePhoneNumberSubmit = async () => {
        setIsLoading(true);

        let result = await forgotPassword(unformatPhoneNumber(mobileNumber));

        if (result.success) {
            setPhoneNumberEntered(true);
        } else {
            setErrorMessage(result.error);
        }

        setIsLoading(false);
    };

    return (
        <Row>
            <Col xs={12} lg={{ offset: 2, size: 8 }}>
                <LoadingOverlay show={isLoading} inBootstrapColumn={true} />

                {phoneNumberEntered ? (
                    <SetPasswordWorkflow
                        phoneNumber={mobileNumber}
                        onPasswordSubmit={resetPassword}
                        changePhoneNumberEvent={() => setPhoneNumberEntered(false)}
                        setIsLoading={setIsLoading}
                        setErrorMessage={setErrorMessage}
                        verificationCodeInputLabel={
                            'A verification code has been sent to the number you provided. ' +
                            'Enter the code below to reset your password.'
                        }
                        passwordButtonLabel="Reset Password"
                        verificationSectionHeader="Reset Password"
                        passwordSectionHeader="Reset Password"
                        allowPhoneNumberChange={false}
                        persistVerificationCode={true}
                    />
                ) : (
                    <div>
                        <h3 className="prospect-signup-header">Reset Password</h3>
                        <ProspectPhoneNumberEntry
                            buttonText="Request Reset Code"
                            phoneNumberValue={mobileNumber}
                            onChange={value => setMobileNumber(unformatPhoneNumber(value))}
                            onSubmit={handlePhoneNumberSubmit}
                            helpText="This is where we'll send your password reset code"
                        />
                    </div>
                )}
                <section className="remember-password">
                    {'Remember your password? '}
                    <Link to="/prospect/login">Sign In</Link>
                </section>

                <FormValidationDisplay errorMessage={errorMessage} />
            </Col>
        </Row>
    );
};

export default PasswordResetPage;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/public/PasswordResetPage.tsx